var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BButton',_vm._b({attrs:{"id":"btn-copy-item"},on:{"click":_vm.cloneItem}},'BButton',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Copy")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }